import { CRUDAction, FeatureKey } from 'common/constants/permission'
import useMedia from 'common/hooks/useMedia'
import { useSpeciesName } from 'modules/pond/api/selector'
import { usePermitToActionFeature } from 'modules/user/api/selector'
import { useTranslation } from 'react-i18next'

import { Card } from '@mui/material'
import { Typography } from '@mui/material'
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'

import { RecordFeatureButton } from 'components/RecordFeatureButton'

import DeadShrimpChart from '../DeadShrimpChart'
import DeadShrimpDialog from '../DeadShrimpDialog'
import DeadShrimpTable from '../DeadShrimpTable'
import DeadSummaryTodayCard from '../DeadSummaryTodayCard'

const DeadShrimp = () => {
  const { t } = useTranslation('deadshrimp')
  const isMobile = useMedia('sm')
  const speciesName = useSpeciesName()

  const showRecordBtn = usePermitToActionFeature([CRUDAction.Create], FeatureKey.Death)

  return (
    <Box sx={{ py: isMobile ? 0 : 3 }}>
      <RecordFeatureButton
        buttonText={t('record.dead.species', { speciesName })}
        dialog={({ open, onClose }) => open && <DeadShrimpDialog open={open} onClose={onClose} />}
        showButton={showRecordBtn}
      />
      <Grid container spacing={2} sx={{ height: 'max-content' }}>
        <Grid item xs={12}>
          <Card
            sx={{
              p: 3,
            }}
          >
            <Typography mb={4} fontSize={18} fontWeight={600}>
              {t('dead.shrimp', { speciesName })}
            </Typography>
            <DeadSummaryTodayCard />
            <DeadShrimpChart />
          </Card>
        </Grid>
        <Grid item xs={12}>
          <DeadShrimpTable />
        </Grid>
      </Grid>
    </Box>
  )
}

export default DeadShrimp
